<!-- Contenedor principal -->
<div class="relative min-h-screen bg-background">
  <!-- Navbar -->
  <lib-navbar [companyLogoUrl]="companyLogoUrl()"></lib-navbar>

  <!-- Overlay (debajo del sidebar, encima de todo lo demás) -->
  @if (isSidebarOpen$ | async) {
    <div (click)="onToggleSidebar()" class="fixed inset-0 z-40 bg-black/20"></div>
  }

  <!-- Sidebar (POR ENCIMA DE TODO) -->
  <div
    class="fixed top-0 left-0 bottom-0 z-50 w-64 bg-transparent transform transition-transform duration-300 ease-in-out"
    [class.-translate-x-full]="(isSidebarOpen$ | async) === false"
  >
    <lib-sidebar class="h-full"></lib-sidebar>
  </div>

  <!-- Layout normal -->
  <div class="flex pt-17 h-[calc(100vh)] overflow-hidden">
    <!-- Contenido -->
    <main class="flex-1 overflow-y-auto px-4 py-4 md:px-6">
      <lib-screen-spinner spinnerId="dashboard"></lib-screen-spinner>
      <ng-content></ng-content>
    </main>
  </div>
</div>
